class ImageSlider extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector("[data-track]");
    this.sliderButtons = this.querySelectorAll("button");
  }

  connectedCallback() {
    this.sliderButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        index === 0 ? this.showPreviousSlide() : this.showNextSlide();
      });
    });

    const itemsToObserve = [
      Array.from(this.track.children).at(0),
      Array.from(this.track.children).at(-1),
    ];

    itemsToObserve.map((item, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.sliderButtons[index].disabled = true;
            } else {
              this.sliderButtons[index].disabled = false;
            }
          });
        },
        {
          root: this.track,
          threshold: 0.5,
        },
      );

      observer.observe(item);
    });
  }

  showNextSlide() {
    this.track.scrollBy({
      left: this.track.firstElementChild.scrollWidth,
      behavior: "smooth",
    });
    this.sliderButtons[0].disabled = false;
  }

  showPreviousSlide() {
    this.track.scrollBy({
      left: -this.track.firstElementChild.scrollWidth,
      behavior: "smooth",
    });
  }
}

customElements.define("image-slider", ImageSlider);
